export const icpPartnerDisclaimer = 'Layanan Komisi Instan Pinhome didukung oleh PT Indo Fin Tek yang terdaftar dan diawasi oleh OJK.';